module.exports = __webpack_public_path__ + "img/gun.3bf2d01b.png";